import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "children", "onClick"];
import { memo } from 'react';
import styled from 'foundations-theming/utils';
import BaseButton from 'unsubscribe-ui/components/core/buttons/BaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultPrimaryButton = styled(BaseButton)(({
  theme
}) => ({
  backgroundColor: theme.color['fill-primary-default'],
  borderColor: theme.color['border-primary-default'],
  color: theme.color['text-primary-default'],
  cursor: 'pointer',
  ':hover': {
    backgroundColor: theme.color['fill-primary-hover'],
    borderColor: theme.color['border-primary-default'],
    color: theme.color['text-primary-default'],
    cursor: 'pointer'
  },
  ':active': {
    backgroundColor: theme.color['fill-primary-pressed'],
    borderColor: theme.color['border-brand-default'],
    color: theme.color['text-primary-default']
  }
}));
const DisabledPrimaryButton = styled(BaseButton).attrs({
  'aria-disabled': true
})(({
  theme
}) => ({
  backgroundColor: theme.color['fill-primary-disabled'],
  borderColor: theme.color['border-primary-disabled'],
  color: theme.color['text-primary-disabled'],
  cursor: 'not-allowed',
  ':hover': {
    backgroundColor: theme.color['fill-primary-disabled'],
    borderColor: theme.color['border-primary-disabled'],
    color: theme.color['text-primary-disabled'],
    cursor: 'not-allowed'
  },
  ':active': {
    backgroundColor: theme.color['fill-primary-disabled'],
    borderColor: theme.color['border-primary-disabled'],
    color: theme.color['text-primary-disabled']
  }
}));
const PrimaryButton = _ref => {
  let {
      disabled,
      children,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (disabled) {
    return /*#__PURE__*/_jsx(DisabledPrimaryButton, Object.assign({}, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(DefaultPrimaryButton, Object.assign({
    onClick: onClick
  }, rest, {
    children: children
  }));
};
export default /*#__PURE__*/memo(PrimaryButton);